export default __webpack_public_path__ + "243e416.svg";